export default __webpack_public_path__ + "static/media/kol_thumb.ac9b853f.png";